<template>
    <tbody>
        <tr>
            <td class="col-xs-2 text-center" style="background-color: #eaeaea;">
                <input type="checkbox" :checked="isSelected" @change.prevent="select">
            </td>

            <td colspan="4" style="background-color: #eaeaea;" @click="isVisible = !isVisible">
                <strong>
                    Subscription #{{ subscription.id }} ({{ subscription.subscriber.name }})
                </strong>

                <div class="btn-group list-actions pull-right">
                    <button type="button" class="btn btn-sm">
                        <i class="fa" :class="{'fa-angle-up': isVisible, 'fa-angle-down': !isVisible}"></i>
                    </button>
                </div>
            </td>
        </tr>

        <template v-if="isVisible">
            <tr
                    is="subscription-period"
                    v-for="subscriptionPeriod in subscription.subscription_periods"
                    :key="subscriptionPeriod.id"
                    :subscription-period="subscriptionPeriod"
                    :portal="subscription.portal"
                    :selected-buyables="selectedBuyables"
                    @add-subscription-period="$emit('add-subscription-period', $event)"
                    @remove-subscription-period="$emit('remove-subscription-period', $event)"
            ></tr>
        </template>
    </tbody>
</template>

<script>
    import SubscriptionPeriod from '@/components/BuyableSelect/SubscriptionPeriod'

    export default {
        components: {SubscriptionPeriod},

        props: ['subscription', 'selected', 'selectedBuyables'],

        data() {
            return {
                isVisible: false
            }
        },

        computed: {
            isSelected() {
                return this.selected.findIndex(existing => existing === this.subscription) > -1
            }
        },

        methods: {
            select() {
                if (this.isSelected) {
                    return this.$emit('remove-subscription', this.subscription)
                }

                return this.$emit('add-subscription', this.subscription)
            }
        }
    }
</script>
